import { render, staticRenderFns } from "./LayersAdding.vue?vue&type=template&id=bcf2ccc0&scoped=true&"
import script from "./LayersAdding.vue?vue&type=script&lang=js&"
export * from "./LayersAdding.vue?vue&type=script&lang=js&"
import style0 from "./LayersAdding.vue?vue&type=style&index=0&id=bcf2ccc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2ccc0",
  null
  
)

export default component.exports